import { createBrowserHistory } from 'history'
import type { JSX } from 'react'
import { Switch, Route, Router } from 'react-router-dom'

import { ROUTES } from 'constants/routes'
import { LoginScreen } from 'screens/LoginScreen'

export const history = createBrowserHistory({
  basename: import.meta.env.VITE_PUBLIC_URL,
})

const App = (): JSX.Element => {
  return (
    <Router history={history}>
      <Switch>
        <Route component={LoginScreen} exact path={ROUTES.LOGIN} />
      </Switch>
    </Router>
  )
}

export default App
